import React, { useEffect, useState, useRef } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { useIsMobile } from '../hooks/useIsMobile';
import { topBarCopy } from '../data/mockData';
interface TopBarProps {
  dateRange: string;
  onDateRangeChange: (r: string) => void;
}
export function TopBar({
  dateRange,
  onDateRangeChange
}: TopBarProps) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const isMobile = useIsMobile();
  const c = topBarCopy;
  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);
  return <header style={{
    position: 'sticky',
    top: 0,
    zIndex: 30,
    background: '#0d1421',
    borderBottom: '1px solid rgba(255,255,255,0.07)'
  }} data-id="element-62">
      <div style={{
      maxWidth: '1120px',
      margin: '0 auto',
      display: 'flex',
      alignItems: 'center',
      padding: isMobile ? '0 16px' : '0 16px',
      height: '48px',
      gap: '12px'
    }} data-id="element-63">
        {/* Brand — left */}
        <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        flexShrink: 0
      }} data-id="element-64">
          <img src="https://cdn.magicpatterns.com/uploads/fFD2RHdyjjzRC42rZY1BHe/BP_logo_copy.png" alt={`${c.appName} logo`} style={{
          width: '24px',
          height: '24px',
          borderRadius: '4px',
          objectFit: 'cover',
          flexShrink: 0
        }} data-id="element-65" />
          <div data-id="element-66">
            <div style={{
            fontSize: isMobile ? '12px' : '13px',
            fontWeight: 600,
            color: '#c8d3e0',
            lineHeight: 1,
            letterSpacing: '0.01em'
          }} data-id="element-67">
              {isMobile ? c.departmentNameShort : c.departmentNameFull}
            </div>
            <div style={{
            fontSize: '10px',
            color: '#3e4f62',
            lineHeight: 1,
            marginTop: '2px',
            letterSpacing: '0.02em'
          }} data-id="element-68">
              {c.appName}
            </div>
          </div>
        </div>

        <div style={{
        flex: 1
      }} data-id="element-69" />

        {/* Date range dropdown — same on mobile and desktop */}
        <div ref={dropdownRef} style={{
        position: 'relative'
      }} data-id="element-70">
          <button onClick={() => setDropdownOpen(!dropdownOpen)} aria-label="Select time range" aria-expanded={dropdownOpen} style={{
          background: 'none',
          border: '1px solid rgba(255,255,255,0.12)',
          borderRadius: '4px',
          padding: '5px 10px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          color: '#8b9ab0',
          fontSize: '12px',
          fontWeight: 500,
          letterSpacing: '0.01em',
          outline: 'none'
        }} onFocus={e => {
          e.currentTarget.style.boxShadow = '0 0 0 2px rgba(59,130,246,0.4)';
        }} onBlur={e => {
          e.currentTarget.style.boxShadow = 'none';
        }} data-id="element-71">
            {dateRange}
            <ChevronDownIcon size={12} color="#4e5f74" data-id="element-72" />
          </button>
          {dropdownOpen && <div style={{
          position: 'absolute',
          top: 'calc(100% + 4px)',
          right: 0,
          background: '#0d1421',
          border: '1px solid rgba(255,255,255,0.1)',
          borderRadius: '4px',
          padding: '4px',
          minWidth: '148px',
          zIndex: 100
        }} data-id="element-73">
              {c.dateRangeOptions.map(opt => <button key={opt} onClick={() => {
            onDateRangeChange(opt);
            setDropdownOpen(false);
          }} style={{
            display: 'block',
            width: '100%',
            textAlign: 'left',
            background: opt === dateRange ? 'rgba(255,255,255,0.05)' : 'none',
            border: 'none',
            borderRadius: '3px',
            padding: '7px 10px',
            cursor: 'pointer',
            color: opt === dateRange ? '#c8d3e0' : '#6b7a8d',
            fontSize: '12px',
            fontWeight: opt === dateRange ? 600 : 400
          }} data-id="element-74">
                  {opt}
                </button>)}
            </div>}
        </div>
      </div>
    </header>;
}